import React from 'react';
import VideoLoop from './VideoLoop';
import About from '../components/About';
import Services from '../components/Services';
import ComoFunciona from './ComoFunciona';

const Home = () => {
  return (
    <main>
      <section id="section1">
        <VideoLoop />
      </section>
      <About />
      <Services />
      <ComoFunciona />
    </main>
  );
};

export default Home;
